<div class="jobseeker-education-info">
  <h3>
    {{ 'label.Education' | translate }}
  </h3>
  <div class="divider"></div>
</div>
<hr-jobseeker-education-item
  *ngFor="let item of jobseeker?.educations"
  [education]="item"
  (onUpdate)="onEducationUpdate($event)"
></hr-jobseeker-education-item>
<hr-education-editor
  *ngIf="isAddModeOn"
  [education]="newEducation"
  (onCancelEdit)="onCancelAddEducation()"
  (onUpdate)="onEducationAdded($event)"
></hr-education-editor>
<button
  class="fa fa-plus btn btn-default"
  type="button"
  (click)="onAddClick()"
  *ngIf="!isAddModeOn"
>
  {{ 'label.Add' | translate }}
</button>
